import { DatastoreInterface } from '@freelancer/datastore/core';
import { assertNever } from '@freelancer/utils';
import {
  CurrencyCode,
  generateCurrencyObject,
} from '../currencies/currencies.mock';
import { ProjectUpgradeFees } from './project-upgrade-fees.model';
import { ProjectUpgradeFeesCollection } from './project-upgrade-fees.types';

export async function createProjectUpgradeFees(
  datastore: DatastoreInterface,
  options: GenerateProjectUpgradeFeesOptions = {},
) {
  const object = generateProjectUpgradeFeesObject(options);
  await datastore.createRawDocument<ProjectUpgradeFeesCollection>(
    'projectUpgradeFees',
    object,
  );
  return object;
}

interface GenerateProjectUpgradeFeesOptions {
  readonly projectId?: number;
  readonly currencyCode?: CurrencyCode.USD | CurrencyCode.AUD;
}

function generateProjectUpgradeFeesObject({
  projectId,
  currencyCode = CurrencyCode.USD,
}: GenerateProjectUpgradeFeesOptions): ProjectUpgradeFees {
  const currency = generateCurrencyObject(currencyCode);
  const id = projectId ? `${currency.id}_${projectId}` : `${currency.id}`;

  switch (currencyCode) {
    case CurrencyCode.USD:
      return {
        id,
        assistedPrice: 9.5,
        assistedFullPrice: 19,
        deletePrice: 5,
        extendPrice: 9,
        featuredPrice: 9,
        freeAssisted: false,
        freeExtend: true,
        freeNda: false,
        freePfOnly: false,
        freeSealed: false,
        freePrivate: false,
        freeUrgent: false,
        freeFeatured: false,
        freeIpContract: false,
        fulltimeCommissionThreshold: 5000,
        fulltimePrice: 199,
        ipContractPrice: 19,
        isTaxIncluded: false,
        ndaPrice: 19,
        nonCompetePrice: 29,
        nonPublicPrice: 19,
        pfOnlyPrice: 9,
        projectManagementPrice: 25,
        sealedPrice: 9,
        successBundlePrice: 23.9,
        urgentPrice: 9,
        currency,
        currencyId: currency.id,
      };

    case CurrencyCode.AUD:
      return {
        id,
        assistedPrice: 9.5,
        assistedFullPrice: 19,
        deletePrice: 5,
        extendPrice: 9,
        featuredPrice: 9,
        freeAssisted: false,
        freeExtend: true,
        freeNda: false,
        freePfOnly: false,
        freeSealed: false,
        freePrivate: false,
        freeUrgent: false,
        freeFeatured: false,
        freeIpContract: false,
        fulltimeCommissionThreshold: 4700,
        fulltimePrice: 199,
        ipContractPrice: 19,
        isTaxIncluded: false,
        ndaPrice: 19,
        nonCompetePrice: 40,
        nonPublicPrice: 19,
        pfOnlyPrice: 9,
        projectManagementPrice: 30,
        sealedPrice: 9,
        successBundlePrice: 29,
        urgentPrice: 9,
        currency,
        currencyId: currency.id,
      };
    default:
      return assertNever(currencyCode);
  }
}
